import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/feature-requests/$requestId")({
  staticData: {
    breadcrumb: "Request",
  },
  component: RequestLayout,
})

function RequestLayout() {
  return <Outlet />
}
